export enum EnvironmentEnum {
    Dev = 'dev',
    Test = 'test',
    Prod = 'prod',
}
